/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {ApiError, RememberMeAuthenticationService, StartRememberMeAuthenticationDTO} from '../../generated/iam-client';
import {from, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {
	iamApiRememberMeAuthenticationStarted,
	iamApiStartRememberMeAuthenticationUnexpectedError,
	iamApiStartRememberMeAuthenticationValidationException
} from './actions';
import {AnyAction} from 'redux';

class RememberMeAuthenticationResource {

	startRememberMeAuthentication(command: StartRememberMeAuthenticationDTO): Observable<AnyAction> {
		const promise = RememberMeAuthenticationService.startRememberMeAuthentication(command);
		return from(promise)
			.pipe(
				map((responseBody) => iamApiRememberMeAuthenticationStarted({result: responseBody})),
				catchError((error: ApiError) => {
					switch (error.status) {
						case 422:
							return of(iamApiStartRememberMeAuthenticationValidationException(error.body));
						default:
							return of(iamApiStartRememberMeAuthenticationUnexpectedError());
					}
				})
			);
	}
}

export default RememberMeAuthenticationResource;
